import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';
import { pxToRem } from '@/theme/typography';

interface CastTitleProps {
  title?: string;
}

export const CastTitle: FC<CastTitleProps> = castTitleProps => {
  return (
    <Typography
      component='h3'
      sx={{
        fontSize: pxToRem(22),
        fontWeight: '700',
        mb: pxToRem(16),
        mt: pxToRem(32),
      }}
    >
      <FormattedMessage id={castTitleProps.title} />
    </Typography>
  );
};

export default CastTitle;
